/** @jsx jsx */
import { jsx } from '@emotion/react';
import { graphql } from 'gatsby';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';
import styled from '@emotion/styled';
import { onSm } from '../styles/responsive';
import Seo from '../components/Seo/Seo';
import Layout from '../components/Layout/Layout';
import { Component } from 'react';
import { Divider } from '../components/MdxComponents/Divider';
import { colors } from '../theme';

const Title = styled.h1`
  font-size: 20pt;
  line-height: 1.5;
  font-weight: 500;
  border-left: 4px solid ${colors.primary};
  padding: 0 16px;
  flex: 1;
  margin-top: 0;
  ${onSm} {
    font-size: 20pt;
  }
`;

const PageTitle = styled.div`
  display: flex;
  flex-flow: wrap;
  align-items: center;
  padding-bottom: 14px;
  color: ${colors.font};
  ${onSm} {
    padding: 15px;
    margin-bottom: 0;
  }
`;

const TitleWrapper = styled.div`
  flex-basis: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const ContentWrapper = styled.div`
  color: ${colors.font};
  flex: 1;
  code {
    background: #656565;
    border: 1px solid black;
    border-radius: 4px;
    padding: 1px 4px;
    font-size: 0.9375em;
    color: ${colors.font};
    // overflow-wrap: break-word;
  }
  section {
    margin: 2px 0;
  }
  ul,
  ol {
    -webkit-padding-start: 40px;
    -moz-padding-start: 40px;
    -o-padding-start: 40px;
    margin: 3px 0px;
    padding: 0px 0px 0px 2em;
  }

  ul li,
  ol li {
    font-size: 15px;
    line-height: 1.7;
    letter-spacing: 0.025em;
  }
`;

export default class DoCTemplate extends Component {
  render() {
    const { data, location } = this.props as any;
    if (!data) {
      return null;
    }
    const { mdx } = data;
    // meta tags
    const { metaTitle } = mdx.frontmatter;
    const docTitle = mdx.fields.title;
    const headTitle = metaTitle || docTitle;

    return (
      <Layout location={location}>
        <Seo frontmatter={mdx.frontmatter} url={location.href} title={headTitle} />
        <PageTitle>
          <TitleWrapper>
            <Title>{docTitle}</Title>
          </TitleWrapper>
        </PageTitle>
        <Divider style={{ marginTop: '7px', marginBottom: '30px' }} />
        <ContentWrapper>
          <MDXRenderer path={mdx?.fields?.slug}>{mdx.body}</MDXRenderer>
        </ContentWrapper>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { id: { eq: $id } }) {
      fields {
        id
        title
        slug
      }
      body
      tableOfContents
      parent {
        ... on File {
          relativePath
          fields {
            gitLogLatestAuthorName
            gitLogLatestAuthorEmail
            gitLogLatestDate(fromNow: true)
          }
        }
      }
      frontmatter {
        metaTitle
        showMetadata
        editable
        showPreviousNext
        showToc
      }
    }
    configSchema {
      schemaContent
    }
  }
`;
